import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

// Configuration mise à jour pour le projet gpschoolbus
// AJOUT DE "export" ici pour corriger l'erreur de compilation
export const firebaseConfig = {
  apiKey: "AIzaSyBe2-mS7UPLKg2Z8hmFq-UsTzb45gO9CvQ",
  authDomain: "gpschoolbus.firebaseapp.com",
  projectId: "gpschoolbus",
  storageBucket: "gpschoolbus.firebasestorage.app",
  messagingSenderId: "273852717856",
  appId: "1:273852717856:web:c38bd8f7a6919d41b85545",
  measurementId: "G-BTEM0TKZG0"
};

// Initialisation de Firebase
const app = initializeApp(firebaseConfig);

// Exports pour utilisation dans vos services et screens
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, "us-central1"); // Région europe-west3